import React, { Component } from "react";
import { MonoText } from "../StyledText";

class CommentForm extends React.Component {
  render() {
    return (
      <form className="comment-form" onSubmit={this._handleSubmit.bind(this)}>
        <MonoText
          style={{
            marginTop: 18,
            color: this.props.colors.text,
            fontSize: 14,
          }}
        >
          Join the discussion
        </MonoText>
        <div className="comment-form-fields">
          <textarea
            placeholder="Comment:"
            ref={(textarea) => (this._body = textarea)}
          />
        </div>
        <div className="comment-form-actions">
          <button type="submit">Post Comment</button>
        </div>
      </form>
    );
  }

  _handleSubmit(event) {
    event.preventDefault();
    let body = this._body;
    this.props.addComment(body.value, this.props.parentId);
  }
}
export default CommentForm;
